// src/components/Protected.Route.Admin.js
import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { AuthContext } from './AuthContext';

export const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { currentUser, loading } = useContext(AuthContext);

  // If loading is true, Firebase auth check is still in progress
  if (loading) {
    return null; // Don't render anything until the auth check is complete
  }
  const isLoadTesting = (typeof process !== 'undefined' && process && process.env && process.env.REACT_APP_LOAD_TESTING === '1');
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoadTesting || currentUser ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default ProtectedRoute;
